import pandaFilmsLogo from "@/assets/pandafilms-logo.jpeg";
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
}

export function BrandMark({ className }: LogoProps) {
  return (
    <span
      className={cn(
        "relative block shrink-0 overflow-hidden rounded-lg bg-[#1d1c21] shadow-sm ring-1 ring-black/10",
        className
      )}
      aria-hidden="true"
    >
      <img
        src={pandaFilmsLogo}
        alt=""
        draggable={false}
        className="pointer-events-none absolute left-1/2 top-[40%] h-auto w-[210%] max-w-none -translate-x-1/2 -translate-y-1/2 select-none"
      />
    </span>
  );
}

export function PandaFilmsLogo({ className }: LogoProps) {
  return (
    <span
      className={cn(
        "relative block shrink-0 overflow-hidden rounded-2xl bg-[#1d1c21] shadow-sm ring-1 ring-black/10",
        className
      )}
    >
      <img
        src={pandaFilmsLogo}
        alt="PandaFilms"
        draggable={false}
        className="pointer-events-none absolute left-1/2 top-1/2 h-auto w-[185%] max-w-none -translate-x-1/2 -translate-y-1/2 select-none"
      />
    </span>
  );
}
